<template>
  <div v-if="!loading">
    <span
      v-if="languages.length === 1"
      :class="['single-language', isZkm && 'single-language-zkm']"
    >{{ selected }}</span>
    <div v-else class="custom-select" tabindex="0" @blur="isOpen = false">
      <div class="selected-option" @click="isOpen = !isOpen">
        <span>{{ selected.toUpperCase() }}</span>
        <v-icon class="select-icon" color="black"> expand_more </v-icon>
      </div>
      <div v-if="isOpen" class="options-container">
        <div
          v-for="(language, i) in availableLanguages"
          :key="`language-${i}`"
          class="option"
          @click="switchLanguage(language)"
        >
          <span>{{ language.toUpperCase() }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18next from 'i18next'
import { GET_LANGUAGE_CODES_FOR_EVENT } from '../../graphql/translation.graphql'

export default {
  name: 'switch-locale',
  props: {
    eventSlug: {
      default: () => null,
      type: String,
    },
    isZkm: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      selected: i18next.resolvedLanguage.toLowerCase(),
      languages: ['hr', 'en'],
      loading: true,
      isOpen: false,
    }
  },
  computed: {
    availableLanguages() {
      return this.languages.filter(language => language !== this.selected)
    },
  },
  created() {
    if (!this.eventSlug) {
      const fallbackLang = this.getLanguageCodeFromQueryParams()
      this.selected = (fallbackLang || this.selected).toLowerCase()
      i18next.changeLanguage(this.selected)
      this.loading = false
    }
  },
  methods: {
    switchLanguage(language) {
      this.selected = language
      const newLang = language.toLowerCase()
      i18next.changeLanguage(newLang)
      this.$router.push({ query: { ...this.$route.query, lang: newLang } })
      this.isOpen = false
    },
    getLanguageCodeFromQueryParams() {
      const params = new URL(window.location.href).searchParams

      return params.get('lang')
    },
  },
  apollo: {
    getLanguageCodesForEvent: {
      query: GET_LANGUAGE_CODES_FOR_EVENT,
      variables() {
        return {
          slug: this.eventSlug,
        }
      },
      skip() {
        return !this.eventSlug
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          const languageCodesForEvent = data && data.getLanguageCodesForEvent
          const fetchedLanguages =
            (languageCodesForEvent && languageCodesForEvent.translationKeys) || []

          // Merge without overwriting default languages
          this.languages = Array.from(new Set([...this.languages, ...fetchedLanguages]))

          const fallbackLang = this.getLanguageCodeFromQueryParams()

          this.selected = (fallbackLang || fetchedLanguages[0] || this.selected).toLowerCase()
          await i18next.changeLanguage(this.selected)

          if (this.$route.query.lang !== this.selected) {
            this.$router.push({ query: { ...this.$route.query, lang: this.selected } })
          }

          this.loading = false
        }
      },
    },
  },
}
</script>

<style>
.custom-select {
  position: relative;
  display: inline-block;
  width: fit-content;
  outline: none;
}

.selected-option {
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 80px;
  height: 38px;
}

.select-icon {
  pointer-events: none;
}

.options-container {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  z-index: 10;
  padding: 5px;
  margin-top: 5px;
  background: #333333;
}

.option {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  color: white;
  justify-content: center;
}

.option:hover {
  background-color: #555555;
}

select {
  line-height: 120%;
  height: 38px;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  outline: 0;
}
.single-language {
  line-height: 120%;
  height: 38px;
  font-size: 18px;
  font-weight: 700;
  color: #0277bd;
  text-transform: uppercase;
  outline: 0;
}
.single-language-zkm {
  color: #333333;
}
</style>
